import DOMPurify from 'isomorphic-dompurify';

export const sanitizeHtml = (content: string, allowedTags = defaultAllowedTags) => {
  const allowedUri = new RegExp(
    `^(?:(${defaultAllowedProtocols.join('|')}):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))`,
    'i',
  );

  return DOMPurify.sanitize(content, {
    ALLOWED_TAGS: allowedTags,
    ALLOWED_URI_REGEXP: allowedUri,
    ADD_ATTR: ['target', 'rel'],
  });
};

export const defaultAllowedTags = [
  'b',
  'strong',
  'i',
  'em',
  'u',
  'mark',
  'small',
  'sub',
  'sup',
  'p',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'br',
  'hr',
  'ul',
  'ol',
  'li',
  'a',
  'img',
  'div',
  'span',
  'blockquote',
  'table',
  'thead',
  'tbody',
  'tfoot',
  'tr',
  'td',
  'th',
  'caption',
  'code',
  'pre',
  'kbd',
  'cite',
  'q',
];

export const defaultAllowedProtocols = ['http', 'https', 'mailto', 'tel'];
